import { PDP_VISITED_EVENT_TYPE } from "./constants";
import { sendTrackEvent, TrackEventJSON } from "./track-event";

type TrackPdpEventData = {
  actorId: string;
  companyId: string;
  pageDomain: string;
  pagePath: string;
  pageType?: string;
};

export const trackPdpEvent = async (data: TrackPdpEventData) => {
  const trackEventData: TrackEventJSON = {
    event_type: PDP_VISITED_EVENT_TYPE,
    actor_id: data.actorId,
    company_id: data.companyId,
    metadata: {
      page_domain: data.pageDomain,
      page_path: data.pagePath,
      ...(data.pageType && { page_type: data.pageType }),
    },
  };
  await sendTrackEvent(trackEventData);
};
